import axios from 'axios';
import { config_headers, servicelist, URL_API } from '../Config';

export const P402GetDataList= async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios.post(URL_API(`${servicelist.CtService}p_ct_contractor_list`), body, authorization )
                .then(res => {
                    resolve(res.data);
                }).catch((error)=> {
                    reject(error);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}

export const P402GetDataList2 = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios.post(URL_API(`${servicelist.CtService}p_ct_contractor_info`), body, authorization )
                .then(res => {
                    resolve(res.data);
                }).catch((error)=> {
                    reject(error);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}

export const P402CreateData= async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            
            await axios.post(URL_API(`${servicelist.CtService}p_ct_contractor_update`), body, authorization ) 
                .then(res => {
                    resolve(res);
                }).catch((error)=> {
                    reject(error);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}

export const P402CreateData2 = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            
            await axios.post(URL_API(`${servicelist.CtService}p_ct_contractor_staff_update`), body, authorization )
                .then(res => {
                    resolve(res);
                }).catch((error)=> {
                    reject(error);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}


